import React from "react";
import NameMasterPage from "./NameMasterPage";

export default function RequiredMaster() {
  return (
    <NameMasterPage
      title="Required Master"
      subtitle="Used in 'Required For' dropdown of the Indent Sheet."
      apiBase="/requireds"
      templateName="required_template.xlsx"
      testidPrefix="required"
    />
  );
}
